import { Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { InfoBoxCard } from "./CampaignImpactInfoBoxCard";

export const CampaignImpactInfoBoxCardAllUnavailable = () => {
  const i18n = useI18n();

  return (
    <InfoBoxCard
      backgroundColor="action_alt"
      title={i18n.trans(t("flights_airline_portal_airline_view_campaign_error_time_frame_header"))}
    >
      <Text variant="body_2">
        {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_time_frame_body"))}
      </Text>
    </InfoBoxCard>
  );
};
